import { createSelector } from '@ngrx/store';
import { AppState } from '../core.state';
import {UIState} from "./ui.model";

export const selectUIState = createSelector(
  (state: AppState) => state.ui,
  (ui: UIState) => ui
);

export const selectMenuState = createSelector(selectUIState, (state: UIState) => state.menuSettings);

export const selectAppRestrictedState = createSelector(selectUIState, (state: UIState) => state.appRestricted);

export const hasLocationPermission = createSelector(selectUIState, (state: UIState) => state.locationPermission);

export const getSoftCheckState = createSelector(selectUIState, (state: UIState) => state.us_state);
